module.exports = __webpack_public_path__ + "img/banner1.f549a74.jpg";